import { render, staticRenderFns } from "./EffectPostingForm.vue?vue&type=template&id=9a0e09b0&"
import script from "./EffectPostingForm.vue?vue&type=script&lang=js&"
export * from "./EffectPostingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports